import React from 'react';
import { useTranslation } from 'react-i18next';
import { TextInput } from '../../../FlowConfigurationInputs/TextInput/NewTextInput';
import { Dropdown } from '../../../FlowConfigurationInputs';

function EndProcess({ action, variables, setOpenVariable }) {
    const { t } = useTranslation();
    const label = 'CONTENT.CONFIGURATION-FORM.AUTOMS.STOP.';
    const options = {
        dropdown: {
            data: [{
                value: 'completed',
                label: label + 'COMPLETED'
            }, {
                value: 'failed',
                label: label + 'FAILED'
            }],
            defaultValue: 'completed'
        }
    }
    return (
        <div>
            <div className="form-element">
                {t(label + 'STATUS')}
                <Dropdown action={action} inputName="status" options={options.dropdown} />
            </div>
            <div className="form-element">
                {t(label + 'USER-MESSAGE')}
                <TextInput action={action} inputName="displayMessage" variables={variables} setOpenVariable={setOpenVariable} />
            </div>
        </div>
    )
}

export default EndProcess;
